"use strict";
// Base	    Alphabet
// 2        01
// 8        01234567
// 11       0123456789a
// 16       0123456789abcdef
// 32       0123456789ABCDEFGHJKMNPQRSTVWXYZ
// 32       ybndrfg8ejkmcpqxot1uwisza345h769 (z-base-32)
// 36       0123456789abcdefghijklmnopqrstuvwxyz
// 45       0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:
// 58       123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz
// 62       0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ
// 64       ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/
// 67       ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.!~
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE58 = exports.BASE45 = exports.BASE16 = exports.BASE2 = void 0;
exports.BASE2 = '01';
exports.BASE16 = '0123456789abcdef';
exports.BASE45 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:';
exports.BASE58 = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
